<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.65 152.12">
        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" data-name="Layer 1">
            <circle cx="95.33" cy="133.15" r="14.97"/>
            <path d="M54.6 102.86a50.76 50.76 0 0181.45 0M29.24 75.15a87.94 87.94 0 01132.17 0M4 41.83a129.15 129.15 0 01182.65 0"/>
        </g>
    </svg>
</template>
